import { Button, FormControl, FormControlLabel, Grid, Radio, RadioGroup } from "@mui/material";
import { filterPdfTemplateData, mergePdfDataArray } from "../../../Helpers/HelperFunctions";
import { UpdateTemplateDataSpecific } from "../../../Helpers/ApiCall";
import { GetUTCTime } from "../../../Helpers/GetUTCTime";
import { useSelector, useDispatch } from "react-redux";
import { React, useEffect, useState } from "react";
import DoneIcon from "@mui/icons-material/Done";

function RadioElement({ element, elementType, templateId, pdfCategoryData, level, pdfCategoriesType }) {
  const [radioValue, setRadioValue] = useState();
  const storeData = useSelector((state) => state.CommonReducer);
  const dispatch = useDispatch();

  let templateIndex = storeData?.inspectionData?.data?.inspectiontemplates?.findIndex((itm) => itm.template_id === templateId);
  let prevData = storeData?.inspectionData?.data;
  let pdfTemplate = prevData?.inspectiontemplates[templateIndex];
  let mergeId = element?.merge_id;
  let ElementpdfData = pdfTemplate?.pdf_data?.filter((item) => item?.merge_id === mergeId);
  let newPrevData = storeData?.inspectionData?.data;
  let newPdfTemplate = newPrevData?.inspectiontemplates[templateIndex];

  const HandleUpdateRadioApiCall = async (radio) => {
    let formData = {
      type: "Radio",
      merge_id: mergeId,
      value: radio,
      updated_at: await GetUTCTime(),
    };
    let payload = {
      guid: storeData?.inspectionData?.data?.guid,
      inspectiontemplates: [
        {
          ...pdfTemplate,
          pdf_data: [formData],
          pdf_categories: [],
        },
      ],
    };
    pdfTemplate.pdf_data = await mergePdfDataArray(pdfTemplate?.pdf_data || [], [formData]);
    newPdfTemplate.pdf_data = await mergePdfDataArray(newPdfTemplate?.pdf_data || [], [formData]);
    UpdateTemplateDataSpecific(dispatch, prevData, payload);
  };



  useEffect(() => {
    // if (ElementpdfData?.[0]?.value) {
    let value = ElementpdfData?.[0]?.value;
    setRadioValue(value === undefined && value === null ? "" : value);
    // }
  }, [ElementpdfData?.[0]?.value]);

  return (
    <>
      <Grid container className={`${elementType === "inner" || elementType === "layout" ? "pdf_container" : "pdf_inner_container"}`}>
        <Grid item xs={12}>
          <FormControl variant="standard" className={`forms-control w-100 ${level === 3 ? "level3_class" : ""}`}>
            <label
              className={
                pdfCategoriesType === 1
                  ? (elementType !== "inner" && elementType !== "layout") || radioValue === "" || radioValue === undefined || (Array.isArray(radioValue) && radioValue?.length === 0) || !radioValue
                    ? "inner_details_title"
                    : "inner_details_title_after_selection"
                  : "inner_details_title"
              }
              id="categoryName"
            >
              {pdfCategoriesType === 1 ? (
                (elementType !== "inner" && elementType !== "layout") || radioValue === "" || radioValue === undefined || (Array.isArray(radioValue) && radioValue?.length === 0) || !radioValue ? (
                  ""
                ) : (
                  <DoneIcon sx={{ marginLeft: "-28px", position: "absolute" }} />
                )
              ) : (
                ""
              )}
              {element?.label}
            </label>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              name="radio-buttons-group"
              onChange={(e) => {
                setRadioValue(e.target.value);
                HandleUpdateRadioApiCall(e.target.value);
              }}
            >
              <Grid container spacing={2} sx={{ marginTop: "2px" }}>
                {element?.elements?.map((item, index) => (
                  <Grid item xs={12} md={6} key={index}>
                    <FormControlLabel
                      className="radio_button radio_icon"
                      key={index}
                      value={item}
                      control={
                        <Radio
                          sx={{
                            height: "19.5px !important",
                            width: "19.5px !important",
                            marginTop: "-1px !important",
                            marginRight: "10px",
                            "& .MuiSvgIcon-root": { fontSize: "19.5px !important" },
                          }}
                          checked={item === radioValue}
                        />
                      }
                      label={item}
                      style={{ display: "flex", alignItems: "flex-start" }}
                    />
                  </Grid>
                ))}
                {radioValue && !Array.isArray(radioValue) ? <Grid item xs={12} md={6}>
                  <Button className="clear-selection-btn" onClick={(e) => {
                    setRadioValue();
                    HandleUpdateRadioApiCall("");
                  }}>Clear selection</Button>
                </Grid> : ""}
              </Grid>
            </RadioGroup>
          </FormControl>
        </Grid>
      </Grid>
    </>
  );
}

export default RadioElement;
